import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { INonCurrentLiabilitiesTableProps } from './types';
import { useExamplePreview } from '../../../../../../../../../hooks/useExamplePreview';
import { ProjectedBalanceFieldTable } from '../../../../components/ProjectedBalanceFieldTable';
import { FIRST_COLUMN_WIDTH, liabilitiesAndEquityPrefix } from '../../../../utils/form';
import {
  LIABILITIES_AND_EQUITY_FORM_NAMES,
  NON_CURRENT_LIABILITIES_TABLE_NAMES,
  useGetLiabilityAndEquityTableHeadings,
} from '../../utils/form';

export const NonCurrentLiabilitiesTable: FC<INonCurrentLiabilitiesTableProps> = ({ disabled = false }) => {
  const period = useWatch({ name: GLOBAL_PERIOD_NAME });
  const { isExamplePage} = useExamplePreview()

  const { getValues } = useFormContext();
  const { nonCurrentLiabilitiesVariants, nonCurrentLiabilitiesTotalRowTitle } = useGetLiabilityAndEquityTableHeadings(isExamplePage);

  const tableName = concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE,
  );

  const totalName = concatWithDot(
    liabilitiesAndEquityPrefix,
    LIABILITIES_AND_EQUITY_FORM_NAMES.NON_CURRENT_LIABILITIES_TABLE_TOTAL,
  );

  const totalValues = getValues(totalName);
  const fields = getValues([
    concatWithDot(tableName, NON_CURRENT_LIABILITIES_TABLE_NAMES.LONG_TERM_DEBT),
    concatWithDot(tableName, NON_CURRENT_LIABILITIES_TABLE_NAMES.DEFERRED_TAX_LIABILITIES),
    concatWithDot(tableName, NON_CURRENT_LIABILITIES_TABLE_NAMES.PENSION_LIABILITIES),
    concatWithDot(tableName, NON_CURRENT_LIABILITIES_TABLE_NAMES.PROVISIONS_NON_CURRENT),
    concatWithDot(tableName, NON_CURRENT_LIABILITIES_TABLE_NAMES.OTHER_NON_CURRENT_LIABILITIES),
  ]);

  return (
    <ProjectedBalanceFieldTable
      disabled={disabled}
      firstColumnWidth={FIRST_COLUMN_WIDTH}
      name={tableName}
      rows={fields}
      rowTitles={nonCurrentLiabilitiesVariants}
      totalRowTitle={nonCurrentLiabilitiesTotalRowTitle}
      totalName={totalName}
      period={period}
      totalValues={totalValues}
    />
  );
};
